import React from "react";
import { SimpleForm, TextInput, Create } from "react-admin";

export default function BasicTextFields() {
  return (
    <>
      <h1>Create New Carousel</h1>
      <Create
        title="Create a new Carousel"
        basePath="/carousels"
        resource="carousels"
      >
        <SimpleForm>
          <TextInput source="title" required />
          <TextInput source="imgurl" required />
          <TextInput source="redirect_url" />
          {/* <TextInput source="type" />
          <TextInput source="extras" options={{ multiLine: true }} /> */}
        </SimpleForm>
      </Create>
    </>
  );
}
